import { render } from "./Inputnumber.vue?vue&type=template&id=560b47af&scoped=true"
import script from "./Inputnumber.vue?vue&type=script&lang=js"
export * from "./Inputnumber.vue?vue&type=script&lang=js"

import "./Inputnumber.vue?vue&type=style&index=0&id=560b47af&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560b47af"]])

export default __exports__